import useAsyncData from "../../../../hooks/use-async-data";
import orderService from "../../order.service";
import OrderCargoOrderDriverSimulation from "./order-cargo-order-driver-simulation";
import OrderCargoOrderDriverSimulationParams from "./order-cargo-order-driver-simulation.params";

const useOrderCargoOrderDriverSimulation = () => {
  const { isLoading, setIsLoading, isError, setIsError, data, setData } =
    useAsyncData<OrderCargoOrderDriverSimulation | null>(null);

  const load = async (
    params: OrderCargoOrderDriverSimulationParams,
    signal: AbortSignal,
  ) => {
    setIsLoading(true);
    setIsError(false);

    try {
      const cargoOrderDetails = await orderService.getDriverSimulation(
        params,
        signal,
      );

      setData(cargoOrderDetails);
      setIsLoading(false);
    } catch (_error) {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    isError,
    data,
    load,
  };
};

export default useOrderCargoOrderDriverSimulation;
